"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sorbo-san-basile": {
    "552a66dc": [{
      "hkey": "61b03ee3",
      "slug": "sorbo-san-basile",
      "name": "Sorbo San Basile",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-melitello": [{
      "hkey": "61b03ee3",
      "slug": "sorbo-san-basile",
      "name": "Sorbo San Basile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6e9f49ed": [{
      "hkey": "61b03ee3",
      "slug": "sorbo-san-basile",
      "name": "Sorbo San Basile",
      "primary": true,
      "skipSearch": false
    }],
    "cutura": [{
      "hkey": "61b03ee3",
      "slug": "sorbo-san-basile",
      "name": "Sorbo San Basile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3e09d8ad": [{
      "hkey": "61b03ee3",
      "slug": "sorbo-san-basile",
      "name": "Sorbo San Basile",
      "primary": true,
      "skipSearch": false
    }],
    "piano-di-moggio-in-sila": [{
      "hkey": "61b03ee3",
      "slug": "sorbo-san-basile",
      "name": "Sorbo San Basile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;